import styled from '@emotion/styled';
import { breakpoints, Fonts, Spacings } from '@styles/index';
import PropTypes from 'prop-types';
import H6 from '@base/H6/H6';
import Batch from '@models/Batch';
import pushRoute from '@utils/pushRoute';

import useBatchDetails from '@api/hooks/batch/useBatchDetails';
import useScrollHandlerGroup from '@hooks/useScrollHandlerGroup';
import { scrollConstants } from '@utils/constants';
import PartnerBadge from 'aquilla/icons/levels/PartnerBadge';
import Tooltip from 'aquilla/core/molecules/Tooltip';
import BottomSheet from '@comp/BottomSheet/BottomSheet';
import Typography from 'aquilla/core/atoms/Typography';
import { useState } from 'react';
import { useIsMobile } from '@stores/AppCommonData';

const EducatorName = styled(H6)`
  cursor: pointer;
  width: max-content;
  display: inline-flex;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    font-size: ${Fonts.H6};
    max-width: 100%;
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacings.SPACING_6};
`;

const Divider = styled.div`
  height: ${Spacings.SPACING_10B};
`;

const DividerLine = styled.div`
  position: absolute;
  width: ${Spacings.SPACING_6B};
  height: 2px;
  left: calc(50% - 12px);
  top: ${Spacings.SPACING_6B};
  background: var(--color-i-gray-13);
  border-radius: 1px;
`;

const BottomSheetHeading = styled(Typography)`
  margin-bottom: ${Spacings.SPACING_2B};
`;

const ToolTipWrapper = styled.div``;

const HeaderEducators = ({ batchUID, educatorSectionRef, isPartnerBatch }) => {
  const { batchDetails } = useBatchDetails(batchUID);
  const { authors } = batchDetails || {};
  const { scrollToElement } = useScrollHandlerGroup([]);
  const [showPartnerInfo, setShowPartnerInfo] = useState(false);
  const isMobile = useIsMobile();

  const togglePartnerInfoBS = () => {
    if (isMobile) setShowPartnerInfo(!showPartnerInfo);
  };

  const scrollToEducatorSection = () => {
    scrollToElement(educatorSectionRef.current, 0, {
      offsetTop: scrollConstants.scroll280
    });
  };

  const handleEducator = () => {
    if (authors.length > 1) scrollToEducatorSection(true);
    else if (authors.length === 1)
      pushRoute('/[authorID]', `/@${authors[0].username}`);
  };

  return (
    <Wrapper>
      {isPartnerBatch && (
        <ToolTipWrapper onClick={togglePartnerInfoBS}>
          {isMobile ? (
            <Wrapper>
              <PartnerBadge width={18} height={18} />
              <EducatorName as="h4" color="var(--color-i-gray-40)">
                Partner educators -{' '}
              </EducatorName>
            </Wrapper>
          ) : (
            <Tooltip
              label="Partner educators are educators affiliated with Unacademy"
              placement="bottom"
              color="var(--color-base-fill)"
            >
              <Wrapper>
                <PartnerBadge width={18} height={18} />
                <EducatorName as="h4" color="var(--color-i-gray-40)">
                  Partner educators -{' '}
                </EducatorName>
              </Wrapper>
            </Tooltip>
          )}
        </ToolTipWrapper>
      )}
      <EducatorName onClick={handleEducator} as="h4">
        {Batch.getAuthorsName(authors)}
      </EducatorName>
      {isPartnerBatch && (
        <BottomSheet
          open={showPartnerInfo}
          onClose={togglePartnerInfoBS}
          icon={<></>}
          contentContainerStyle="padding-bottom: 16px;"
        >
          <Divider>
            <DividerLine />
          </Divider>
          <BottomSheetHeading variant="h5">
            Partner educators
          </BottomSheetHeading>
          <Typography variant="p2">
            Partner educators are educators affiliated with Unacademy.
          </Typography>
        </BottomSheet>
      )}
    </Wrapper>
  );
};

export default HeaderEducators;

HeaderEducators.propTypes = {
  batchUID: PropTypes.string.isRequired
};
